import { Theme } from '@material-ui/core';
import { Translate } from 'react-admin';
import { InventorizationIncorrectStatus, InventorizationStatus } from '../../../entities/InventorizationStatus';

export const NOTE_MAX_LENGTH = 200;

export const getStatusColor = (status: InventorizationStatus | null, theme: Theme): string => {
  switch (status) {
    case InventorizationStatus.correct:
      return theme.palette.success.main;
    case InventorizationStatus.incorrect:
      return theme.palette.error.main;
    default:
      return theme.palette.grey[500];
  }
};

export const getStatusLabel = (
  status: InventorizationStatus | null | undefined,
  translate: Translate
): string => {
  switch (status) {
    case InventorizationStatus.correct:
      return translate('osfc.enums.inventorization_status.correct');
    case InventorizationStatus.incorrect:
      return translate('osfc.enums.inventorization_status.incorrect');
    default:
      return '-';
  }
};

export const getIncorrectStatusLabel = (
  incorrectStatus: InventorizationIncorrectStatus | null | undefined,
  translate: Translate
): string => {
  switch (incorrectStatus) {
    case InventorizationIncorrectStatus.place_empty:
      return translate('osfc.enums.inventorization_incorrect_status.place_empty');
    case InventorizationIncorrectStatus.pallet_missing:
      return translate('osfc.enums.inventorization_incorrect_status.pallet_missing');
    case InventorizationIncorrectStatus.wrong_pallet:
      return translate('osfc.enums.inventorization_incorrect_status.wrong_pallet');
    default:
      return '-';
  }
};

/**
 * Label of a (status, incorrect status) pair as one string: an incorrect status is
 * named by its reason, everything else by the status itself.
 */
export const getDetailedStatusLabel = (
  status: InventorizationStatus | null | undefined,
  incorrectStatus: InventorizationIncorrectStatus | null | undefined,
  translate: Translate
): string => (
  status === InventorizationStatus.incorrect
    ? getIncorrectStatusLabel(incorrectStatus, translate)
    : getStatusLabel(status, translate)
);
